import { Orcamento } from '@/contracts/schemas';
import { formatDateBR, getStatusLabel } from './orcamento-calc';

/**
 * Exporta a lista de orçamentos para um arquivo CSV formatado para Excel em Português do Brasil.
 * Utiliza ponto e vírgula como separador e inclui o marcador BOM UTF-8 (\uFEFF)
 * para abertura direta no Microsoft Excel sem desconfigurar caracteres acentuados.
 */
export function exportProposalsToCSV(orcamentos: Orcamento[]): void {
  if (!orcamentos || orcamentos.length === 0) {
    throw new Error('Nenhum orçamento para exportar.');
  }

  const cabecalhos = [
    'Número',
    'Data de Emissão',
    'Validade',
    'Cliente',
    'Telefone / WhatsApp',
    'Serviço Contratado',
    'Qtd de Itens',
    'Subtotal (R$)',
    'Desconto (R$)',
    'Valor Total (R$)',
    'Sinal Pix (R$)',
    'Saldo Restante (R$)',
    'Status Atual',
    'Chave Pix Recebedora',
    'Titular Pix',
  ];

  const escapeCSV = (valor: string | number | undefined | null): string => {
    if (valor === undefined || valor === null) return '""';
    const str = String(valor).replace(/"/g, '""');
    return `"${str}"`;
  };

  const formatValorNumerico = (v: number): string => {
    return (v || 0).toFixed(2).replace('.', ',');
  };

  const linhas = orcamentos.map((orc) => {
    return [
      escapeCSV(orc.numero),
      escapeCSV(formatDateBR(orc.dataCriacao)),
      escapeCSV(formatDateBR(orc.dataValidade)),
      escapeCSV(orc.cliente.nome),
      escapeCSV(orc.cliente.telefone),
      escapeCSV(orc.titulo),
      escapeCSV(orc.itens.length),
      escapeCSV(formatValorNumerico(orc.valorSubtotal)),
      escapeCSV(formatValorNumerico(orc.desconto)),
      escapeCSV(formatValorNumerico(orc.valorTotal)),
      escapeCSV(formatValorNumerico(orc.valorSinal)),
      escapeCSV(formatValorNumerico(orc.valorRestante)),
      escapeCSV(getStatusLabel(orc.status)),
      escapeCSV(orc.perfilMei.chavePix),
      escapeCSV(orc.perfilMei.nome),
    ].join(';');
  });

  const conteudoCSV = '\uFEFF' + [cabecalhos.join(';'), ...linhas].join('\r\n');
  const blob = new Blob([conteudoCSV], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const dataHoje = new Date().toISOString().slice(0, 10);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `zaporca-relatorio-orcamentos-${dataHoje}.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
